
async function locationFinder(thisel, fieldId) {
	var button = $(thisel).parent().parent();

	let search = button.find('[name="lf"]').val();
	if(search === "" || search === 'false') {
		search = button.find('#'+fieldId).val();
		button.find('[name="lf"]').val(search);
	}

	//if search doesn't resemble a postal code, or a partial postal code, run a couple geocoding requests to convert the search to coordinates, and the coordinates to a postal code
	const canada_postal_code_regex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]([ -]?\d[ABCEGHJ-NPRSTV-Z]\d)?$/i;

	if ( !search.match(canada_postal_code_regex) ) {
		let coordinates = await get_coordinates_from_search_string(search);
		if(coordinates) {
			let reverse_postal_code = await get_postal_code_from_coordinates(coordinates);
			if(reverse_postal_code) {
				search = reverse_postal_code;
				button.find('[name="lf"]').val(search); //write the search back to the form hidden field
			} else {
			}
		} else {
		}
	}

	if(fieldId == 'autocompletefooter') {
		var callfrom = 'autocompletefooter';
	} else {
		//alert(fieldId == 'autocomplete2');
		var callfrom = button.find('#'+fieldId).attr('id');
	}


	var matches = search.match(/\d+/g);
	//alert(matches);
	//console.log('111111111111111');
	//console.log(matches);
	var countrySelected = 'ca';

	if(matches == null) {

		if(search.indexOf(",") >= 0) {
			// console.log('City, State valid');
		} else {
			// console.log('City, State invalid');
			//trackSearch(search + ' (' + countrySelected + ')', 'not-valid');
			$('.not-valid-modal').modal();
			//alert('Not a Valid Location!');

			return false;
		}
	}
	var form;
	if(button.hasClass('design-consultant-form')) {
		form = 'our-designers';
	} else {
		form = 'default';
	}
	// prevent from pinging the server if the honeypot field is not empty
	if(button.find('.hidden-field').val() !== "" || button.find('[name="lf"]').val() == "") {

		return false;
	}


	$.ajax({
		async: false,
		url       : ajaxurl,
		data      : {
			action  : 'location-finder',
			search  : button.find('[name="lf"]').val(),
			area    : button.find('.area').val(),
			form    : form,
			callfrom: callfrom,
			honeypot: button.find('.hidden-field').val(),
			// send the nonce along with the request
			nonce: button.find('.nonce').val(),
			wpml_lang: wpml_lang
		},
		method    : "POST",
		dataType  : "json",
		beforeSend: function() {
			$(thisel).attr('disabled', true);
			$(thisel).find('.cc-loading-spinner--screen-reader').text(function (){return $(this).data('loading-label')});
			// console.log("Finder ... Before send..");
		},
		error     : function(error) {
			console.log("Finder ... Got Error..");
			console.log(error);
			//console.log("postal code: "+error.zipcode);
			//reset hidden field with geocoding autocomplete
			button.find('[name="lf"]').val('')
		},
		success   : function(response) {
			// console.log("Finder ... Success.. ");
			$('.mobile-header .mobile-locate-me a').removeClass('active');
			// console.log("Errors: "+response.errors);

			if ( response.errors == '' ) {

				// console.log('opening location page URL:', response.url, 'Target:', response.target);

				let location_window_reference = window.open(response.url, response.target);

				//if the target is not this same page, check if the popup worked (and reload the page), or show a modal window otherwise.
				if (response.target !== '_self') {
					if (location_window_reference == null) {
						// console.log('window.open failed. showing modal');

						$('.location-found-modal')
							.find('.location-found-link')
							.attr('href', response.url)
							.attr('target', response.target)
							.on('click', function(e) {
								// Page reload required to properly show location in case user returns to primary website
								window.setTimeout(function(){
									// console.log('reloading page - modal link clicked');
									window.location.reload();
								},1000);
							})
							.end()
							.modal()
						;
					} else {
						// Page reload required to properly show location in case user returns to primary website
						if ( response.target === '_blank' ) {
							window.setTimeout(function(){
								// console.log('reloading page - external tab opened');
								window.location.reload();
							},1000);
						}
					}
				}

			}
			else {
				$(thisel).attr('disabled', false);
				$(thisel).find('.cc-loading-spinner--screen-reader').text('');
				$('.not-found-modal').modal();
				// console.log('triggered not-found-modal')
			}
			//reset hidden field with geocoding autocomplete
			button.find('[name="lf"]').val('')
		}
	});

}

/* check if a location is set */
const checkIfLocationFound = () => {

	const ajaxData = {
		action: 'calclosets_location_found',
		wpml_lang: wpml_lang
	}

	const getUrlParameter = (sParam) => {

		const sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&');

		let	i;

		for ( i = 0; i < sURLVariables.length; i++ ) {

			const sParameterName = sURLVariables[i].split('=');

			if ( sParameterName[0] === sParam ) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};

	if ( getUrlParameter('CC1') ) {
		ajaxData.franchise_id = getUrlParameter('CC1');
	}

	$.ajax({
		type   : 'GET',
		url    : ajaxurl,
		headers: {
			'Cache-control': 'max-age=86400, public',
			'Pragma'       : 'cache'
		},
		cache  : true,
		data   : ajaxData,
		success: function(res) {

			const result = JSON.parse(res);

			if ( result.code == 200 ) {

				$('.location-found').each(function() {

					$(this)
						.siblings()
						.addClass('inactive')
						.hide();

					$(this)
						.removeClass('hide')
						.find('.market-name')
						.attr('href', result.url)
						.attr('target', result.target)
						.html(result.name);
				});
			}
			fetchEntireContent();
		}
	});
}

jQuery(document)
	.ready(function($) {

		//load default phone number. might be replaced by more-accurate phone number if location found. might also be
		// replaced by other numbers due to Invoca
		prepopulatePhoneNumber();

		//load current location. might update phone numbers
		checkIfLocationFound();


		$('.lf-dropdown .selected')
			.on('click', function() {
				var current = $(this)
					.attr('data-current'),
					parent = $(this)
						.parent();

				//$('.lf-select option').attr('selected', false);
				parent.find('li')
					.show();
				parent.find('ul')
					.stop()
					.slideToggle()
					.find('li')
					.eq(current)
					.hide();
				setForm(parent.parents('form'));
				changeCountry();
			});

		$('.lf-finder-footer').on('click', function(e) {

				e.preventDefault();
				e.stopPropagation();
				var thisel = this;
				this.disabled = true;
				locationFinder(thisel, 'autocompletefooter');
				this.disabled = false;
				return false;
		});
		/*$( document ).on( 'click', '.lf-finder', function( e ) {*/
		$('.lf-finder').on('click', function(e) {

			if (window.cc_lf_in_progress) {
				return; // prevent multiple invocations. it happens when using down arrow and enter to select an autocomplete option.
			}
			window.cc_lf_in_progress = true;
			setTimeout(function() {window.cc_lf_in_progress = false;}, 1000);

				e.preventDefault();
				e.stopPropagation();
				var thisel = this;
				this.disabled = true;
				setTimeout(function() {
					locationFinder(thisel, 'autocomplete');
					thisel.disabled = false;
				}, 500);
				return false;
		});

		$('[class^="lf-finder-"]').on('click', function(e) {
				let currId = $(this).attr('id');
				currId = currId.replace('finder-', '');
				//alert(currId);
				e.preventDefault();
				e.stopPropagation();
				var thisel = this;
				this.disabled = true;
				setTimeout(function() {
					locationFinder(thisel, 'autocomplete'+currId);
					thisel.disabled = false;
				}, 500);
				return false;
		});

		$('body').on('click', '.lf-change', '.lf-form-mobilee', function(e) {
				e.stopPropagation();
				var locationFound;
				$('#autocomplete').val('');
				if($(this).parent().parent().hasClass('showroom-cookie')) {
					locationFound = $(this).parent().parent();
				} else {
					locationFound = $(this).parent();
				}

				locationFound.hide();

				$(this).parent('div').find('.inactive').show();
				if(locationFound.hasClass('showroom-cookie')) {
					locationFound.next().css('display', 'table-cell');
				} else {
					locationFound.next().show();
				}

				$(document.body).on('click.location-finder', function() {
						var $body = $(this);
						$('#autocomplete').val('');
						locationFound.show();
						$('.lf-form.inactive').hide();
						$('.lf-form-mobilee.inactive').hide();
						$('.inactive.mobile-form').hide();
						$body.off('click.location-finder');
					});
		});

		$('.lf-form').on('click', function(e) {
			e.stopPropagation();
		});
		$('.lf-form-mobilee').on('click', function(e) {
			e.stopPropagation();
		});
});
var priceOffer = function(string) {
	var cond = false;
	if(jQuery('body')
			.hasClass('en')) {
		if(string.toLowerCase()
				.indexOf('cost') > -1 || string.toLowerCase()
				.indexOf('price') > -1) {
			cond = true;
		}
	} else if(jQuery('body')
			.hasClass('fr')) {
		if(string.toLowerCase()
				.indexOf('coût') > -1 || string.toLowerCase()
				.indexOf('prix') > -1 || string.toLowerCase()
				.indexOf('cout') > -1) {
			cond = true;
		}
	} else {
		if(string.toLowerCase()
				.indexOf('costo') > -1 || string.toLowerCase()
				.indexOf('precio') > -1) {
			cond = true;
		}
	}
	if(cond) {
		window.location.replace(designerURL);
	}
	return cond;
};
jQuery(document)
	.on('submit', '.mobile-menu-search form', function(e) {
		if(priceOffer(jQuery(this)
				.find('[name="s"]')
				.val())) {
			e.preventDefault();
		}
	});
